import { DB } from "@/services/firebase/db"
import Expenditure from "@/types/expenditure/expenditure"
import { Auth } from "@/services/firebase/auth"

export class ExpenditureService {
  storeExpenditureForTracking (trackingId: string, expenditure: Expenditure) {
    return DB.collection('expenditures').doc().set({
      quantity: Number(expenditure.quantity),
      position: expenditure.position,
      positionPrice: Number(expenditure.positionPrice),
      totalPrice: Number(expenditure.totalPrice),
      trackingId: trackingId
    })
  }

  getExpendituresForTracking (trackingId: string) {
    return DB.collection('expenditures')
      .where('trackingId', '==', trackingId)
      .get()
      .then((expenditureQuery) => {
        return expenditureQuery.docs.map((doc) => {
          return new Expenditure({
            id: doc.id,
            ...doc.data()
          })
        })
      })
  }

  getExpendituresForTrackings (trackingIds: string[] | null) {
    const collectionPath = DB.collection('expenditures')
    const requests = []
    while (trackingIds!.length) {
      const slicedIds = trackingIds!.splice(0, 10)
      requests.push(
        collectionPath
          .where('trackingId', 'in', [...slicedIds])
          .get()
          .then((expenditureQuery) => {
            return expenditureQuery.docs.map((doc) => {
              return new Expenditure({
                id: doc.id,
                ...doc.data()
              })
            })
          })
      )
    }
    return Promise.all(requests)
      .then(content => content.flat())
  }

  updateExpendituresTrackingId (currentTrackingId: string, newTrackingId: string) {
    return DB.collection('expenditures')
      .where('trackingId', '==', currentTrackingId)
      .get()
      .then((expenditureQuery) => {
        return expenditureQuery.docs.map((doc) => {
          return DB.collection('expenditures').doc(doc.id).set({
            trackingId: newTrackingId
          }, { merge: true })
        })
      })
  }

  updateExpenditureData (expenditureId: string, expenditure: Expenditure) : Promise<void | undefined> {
    return DB.collection('expenditures').doc(expenditureId).set({
      quantity: Number(expenditure.quantity),
      position: expenditure.position,
      positionPrice: Number(expenditure.positionPrice),
      totalPrice: Number(expenditure.totalPrice)
    }, { merge: true })
  }

  removeExpenditureById (expenditureId: string) {
    return DB.collection('expenditures').doc(expenditureId).delete()
  }

  removeExpendituresForTracking (trackingId: string) {
    return DB.collection('expenditures')
      .where('trackingId', '==', trackingId)
      .get()
      .then((expenditureQuery) => {
        expenditureQuery.forEach((doc) => {
          doc.ref.delete()
        })
      })
  }

  removeExpendituresForTrackings (trackingIds: string[] | null) {
    const collectionPath = DB.collection('expenditures')
    const requests = []
    while (trackingIds!.length) {
      const slicedIds = trackingIds!.splice(0, 10)
      requests.push(
        collectionPath
          .where('trackingId', 'in', [...slicedIds])
          .get()
          .then((expenditureQuery) => {
            expenditureQuery.forEach((doc) => {
              doc.ref.delete()
            })
          })
      )
    }
    return Promise.all(requests)
      .then(content => content.flat())
  }
}
